<template>
  <div class="mobile-minicart">
    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="mobile-minicart-toggle"
    >
      <tbody>
        <tr>
          <td width="50%"><b>Due Today: </b>{{ formatAmount(quoteTotal) }}</td>
          <td width="50%" align="right">
            <span @click="showMobileCart()">Your Quote</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import { calculateQuoteTotal, formatAmount } from "@/utils/Utils";
import { defineComponent, inject, computed, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";

const inj = inject("$emitter");
const quote = useQuoteStore();

function showMobileCart() {
  (inj as any).emit("show-mobile-cart");
}

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});
</script>
